/*
  GGP — auto-rotating carousel for Dawn's slider-component.
  Advances one viewport (~one page of cards) on an interval and loops back to
  the start. Pauses on hover/focus and respects reduced-motion preferences.
  Activated by adding `data-ggp-autoplay` to a <slider-component>.
*/
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(component) {
    if (component.dataset.ggpAutoplayReady === 'true') return;
    component.dataset.ggpAutoplayReady = 'true';

    var slider = component.querySelector('[id^="Slider-"]');
    if (!slider) return;

    var interval = parseInt(component.dataset.ggpAutoplayInterval, 10) || 4000;
    var timer = null;
    var paused = false;

    function atEnd() {
      return slider.scrollLeft >= slider.scrollWidth - slider.clientWidth - 4;
    }

    function advance() {
      if (paused) return;
      // Only autoplay while the desktop slider layout is active.
      if (slider.clientWidth >= slider.scrollWidth - 4) return;

      if (atEnd()) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        slider.scrollBy({ left: slider.clientWidth, behavior: 'smooth' });
      }
    }

    function start() {
      if (reduceMotion || timer) return;
      timer = window.setInterval(advance, interval);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    component.addEventListener('mouseenter', function () {
      paused = true;
    });
    component.addEventListener('mouseleave', function () {
      paused = false;
    });
    component.addEventListener('focusin', function () {
      paused = true;
    });
    component.addEventListener('focusout', function () {
      paused = false;
    });

    // Pause while the tab is hidden to avoid jumpy catch-up scrolling.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    start();
  }

  function boot() {
    document.querySelectorAll('slider-component[data-ggp-autoplay]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
